import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { v_LocationDetailBus } from './v_LocationDetailBus';
import { EquipFieldData } from './EquipFieldData';
import { CommonFunctions } from '../static/common-functions';
/*
 * hidden - dispatchEquipmentXrefId
 * hidden - dispatchId
 * (checkbox)
 *Equipment Id: systemId
 * Manufacturer: manufacturerName manufacturerId
 * Model : model
 * (Additional Details - button)
 * Serial #: serialNumber
 * Type: manufacturerTypeName manufacturerTypeId
 * Barcode: barcode
 * Notes: notes
 * Created By: createdBy
 * Date Created: creationDate;
 * (View Inventory Items Used - button)
 */
export class VehicleMaintExpenseBus extends BaseBus
{
    constructor(data: VehicleMaintExpenseBus) {
        super(data);
        if (data) {
            if (data.costCenterName) {
                this.costCenterNameLong = data.costCenter + " - " + data.costCenterName;
            }
            this.recordDt = CommonFunctions.getDate(data.recordDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.sentToPayrollDt = CommonFunctions.getDate(data.sentToPayrollDt);

        }

    }

    setId(id: any) {
        this.vehicleMaintHistId = id;
    }
    CID(): any {
        return this.vehicleMaintHistId;
    }
    initialize(data: VehicleMaintExpenseBus) {
        super.initialize(data);
        this.recordDt = CommonFunctions.getDate(data.recordDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
        this.insertDt = CommonFunctions.getDate(data.insertDt);

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: VehicleMaintExpenseBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        //this.updateDt = dateNow;
        //if (this.hasId) {
        //    //this.updateDt = dateNow;
        //    this.insertDt = data.insertDt;
        //    this.insertUserId = data.insertUserId;
        //}
        //else {
        //    this.insertDt = dateNow;
        //    this.insertUserId = data.insertUserId;
        //}

    }
    setBeforeSave() {
        //this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
          //  this.updateUserId = userId;
        }
        else {
            //this.insertDt = date;
            //this.insertUserId = userId;
            //this.updateUserId = userId;
        }
    }

    vehicleMaintHistId: string;
    recordTypeId: number;
    recordTypeName: string;
    note: string;
    recordDt: Date;
    insertDt: Date;
    updateDt: Date;
    insertUserId: string;
    vehicleId: string;
    mileage: string;
    haveReceipt: string;
    amount: number;
    companyId: string;
    gallons: number;
    mpg: number;
    vehicleName: string;
    assignedPersonId: string;
    sentToPayroll: boolean;
    reimburse: boolean;
    approved: boolean;
    photoCount: string;
    userName: string;
    costCenter: string;
    branchName: string;
    costCenterName: string;
    managerName: string;
    lineOfBusiness: string;
    incomeStatementCat: string;
    empNo: string;
    creditCard: string;
    cos: string;
    ovh: string;
    branchCode: string;
    insertUsername: string;
    attachmentDetailFullName: string;
    attachment: any;
    attachmentType: string;
    attachmentName: string;
    costCenterNameLong: string;
    sentToPayrollUserId: string;
    sentToPayrollUserName: string;
    sentToPayrollDt: Date

}
